<template>
    <div>
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
				<v-btn 
					small 
					class="btn-save"
					@click="printPreview"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
            </div>
        </v-card> 

        <v-row class="mx-1 mt-5">
            <v-col cols="12" md="3">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="text"
                    item-value="value"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    type="number"
                    attach
                    dense
                    clearable
                ></v-text-field>
            </v-col>

			<v-col cols="12" md="2" class="d-flex justify-center">
				<v-btn
					small
					class="btn-save"
					:disabled="verificationBalanceRunning"
					:loading="verificationBalanceRunning && verificationBalanceAction === 'consult'"
					@click="getVerificationBalanceData(false)"
				>
					Consultar Datos
				</v-btn>
				<!-- <div class="d-flex align-center">
				</div> -->
			</v-col>
			<v-col cols="12" md="2" class="d-flex justify-center">
				<v-btn
					small
					class="btnclean"
					:disabled="verificationBalanceRunning"
					:loading="verificationBalanceRunning && verificationBalanceAction === 'refresh'"
					@click="getVerificationBalanceData(true)"
				>
					Recalcular Datos
				</v-btn>
			</v-col>
			<v-col cols="12" md="2">
				
			</v-col>
        </v-row>

		<v-row class="mx-1 mt-6">
			<form style="display: flex; flex-direction: row; align-items: center; gap: 40px;">
				<div class="book-radio">
					<label for="check-balance-category">
						<input
							type="radio" name="check-balance-category" id="check-balance-category"
							v-model="SheetCheckBalanceType" value="category"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Por rubro
					</label>
				</div>
				<div class="book-radio">
					<label for="check-balance-major-accounts">
						<input
							type="radio" name="check-balance-major-accounts" id="check-balance-major-accounts"
							v-model="SheetCheckBalanceType" value="major-accounts"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Por cuentas de mayor
					</label>
				</div>
				<div class="book-radio">
					<label for="check-balance-subaccounts">
						<input
							type="radio" name="check-balance-subaccounts" id="check-balance-subaccounts"
							v-model="SheetCheckBalanceType" value="subaccounts"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Por Subcuentas
					</label>
				</div>
				<div class="book-radio">
					<label for="check-balance-detailaccounts">
						<input
							type="radio" name="check-balance-detailaccounts" id="check-balance-detailaccounts"
							v-model="SheetCheckBalanceType" value="detailaccounts"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Todas las Cuentas
					</label>
				</div>
			</form>
		</v-row>

		<v-row v-if="loading">
			<v-col>
				<v-progress-linear indeterminate color="primary" class="mb-2"></v-progress-linear>
			</v-col>
		</v-row>

		<v-row v-if="loading">
			<v-col>
				<p class="font-weight-bold">{{ loadingMessage }}</p>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" class="pa-0">
				<div class="check-balance-grid-wrapper">
					<DxDataGrid
						class="check-balance-grid"
						:dataSource="dataSourceRecords"
						:showBorders="true"
						:scrolling="{ useNative: true }"
						:column-auto-width="true"
						@exporting="(e) => onExporting( typesDitionary[ SheetCheckBalanceType ], e )"
					>
						<DxColumn :group-index="0" data-field="source" caption="Tipo"></DxColumn>
						<DxColumn dataField="account_code" caption="Cuenta" />
						<DxColumn dataField="account_description" caption="Nombre" />
						<DxColumn dataField="PreviousBalanceFormatted" caption="SalAnterior" />
						<DxColumn dataField="chargesFormatted" caption="Cargos" />
						<DxColumn dataField="paymentsFormatted" caption="Abonos" />
						<DxColumn dataField="CurrentBalanceFormatted" caption="SalActual" />
						<DxPager :showPageSizeSelector="true" :allowedPageSizes="[5, 10, 20]" />
						<DxPaging :defaultPageSize="10" />
						<DxExport :enabled="true" :formats="['xlsx']" />
					</DxDataGrid>
				</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col md="8">
	
			</v-col>
			<v-col md="4">
				<p style="float:left; margin-right: 140px; text-align: right;">TOTAL ACTIVOS:</p><p style="overflow: hidden; text-align: right;"> {{ this.getTotal( "activos" ) }}</p>
			</v-col>
		</v-row>
		<v-row>
			<v-col md="8">
	
			</v-col>
			<v-col md="4">
				<p style="float:left; margin-right: 140px; text-align: right;">TOTAL PASIVO+CAPITAL:</p><p style="overflow: hidden; text-align: right;"> {{ this.getTotal( "pasivos" ) }}</p>
			</v-col>
		</v-row>
        <alerts
			v-if="alert.show"
			v-on:close_alert="closeAlert"
			v-on:accept_alert="acceptAlert"
			:properties="alert"
		></alerts>
		<PrintCheckBalance :dataProps="print" :balanceDate="balanceDate"></PrintCheckBalance>
    </div>
</template>

<script>
import {DxDataGrid, DxPager, DxPaging, DxColumn, DxExport} from 'devextreme-vue/data-grid';
import PrintCheckBalance from '../../../components/ReportsAndPrintings/PrintCheckBalance.vue';
import alerts from '@/components/Alerts.vue';
import moment from 'moment';
import { numberWithCommas } from "../../../helpers/money";
import { printToExcel } from "@/helpers/printToexcel";

export default {
	name: "SheetCheckBalance",
	components: {
		DxExport,
		DxDataGrid,
		DxPager,
		DxPaging,
		DxColumn,
		PrintCheckBalance,
		alerts
	},
	props: ['win'],
	data() {
		return {
			DataTable: {
				activos: [],
				pasivos: []
			},
			SheetCheckBalanceType: 'category',
			panel: 0,
			tab: null,
			key: 0,
			search:{
				month: '',
				year: `${new Date().getFullYear()}`,
			},
			typesDitionary: {
				category: 'por Rubro',
				subaccounts: 'por Subcuentas',
				detailaccounts: 'Todas la Cuentas',
				"major-accounts": 'por Cuentas de Mayor'
			},
			alert: {
				type: "success",
				show: false,
				header: "",
				body: "",
			},
			loading: false,
			loadingMessage: "",
			verificationBalanceRunning: false,
			verificationBalanceJobId: null,
			verificationBalancePollingTimer: null,
			verificationBalanceAction: null,
			monthList: [
				{text: 'Enero', value: 1},
				{text: 'Febrero', value: 2},
				{text: 'Marzo', value: 3},
				{text: 'Abril', value: 4},
				{text: 'Mayo', value: 5},
				{text: 'Junio', value: 6},
				{text: 'Julio', value: 7},
				{text: 'Agosto', value: 8},
				{text: 'Septiembre', value: 9},
				{text: 'Octubre', value: 10},
				{text: 'Noviembre', value: 11},
				{text: 'Diciembre', value: 12},
			],
			print: {
				show: false,
				data: []
			},
			currencySymbol: JSON.parse(localStorage.getItem('branch')).Currency,
			businessName: JSON.parse(localStorage.getItem("user")).business,
			userData: {}
		}
	},
	watch: {
		SheetCheckBalanceType() {
			this.loading = true;
			this.cleanData();
			this.loading = false;
		},
	},
	mounted() {
		this.userData = JSON.parse(localStorage.getItem("user"))
	},
	beforeDestroy() {
		this.clearVerificationBalancePolling();
	},
	computed:{
		dataSourceRecords() {
			return [
				...this.DataTable.activos,
				...this.DataTable.pasivos
			];
		},
		balanceDateComplete() {
			const currentDate = moment();
	
			currentDate.set( 'month', this.search.month - 1 );
			currentDate.set( 'year', this.search.year );

			return currentDate;
		},
		balanceDate(){
			let currentMonth = this.balanceDateComplete.startOf("month").format('MMMM');

			currentMonth = `${ currentMonth.substring( 0, 1 ).toUpperCase() }${ currentMonth.substring( 1, currentMonth.length ) }`;

			let balanceDate = `${ currentMonth } del ${ this.balanceDateComplete.year() }`;
			return balanceDate;
		},
		columnWidth() {
			return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
		}
	},
	methods: {
		onExporting( label, e) {
			//let array = null;
			//array = ["saldo_anterior"]
			printToExcel(e, `Balance De Comprobación ${ this.balanceDate } (${ label })`);
		},
		getTotal( recordType ) {
            let accum = 0.00;

			console.log( "getTotal -> recordType:", recordType, "DataTable:", this.DataTable );
            for( const record of this.DataTable[ recordType ] ) {
				if( record.Type === 1 ) {
					accum += record.CurrentBalance ? record.CurrentBalance : 0;
				}
			}

            return `${ this.currencySymbol }${ numberWithCommas( accum ) }`;
        },
		cleanData() {
			this.DataTable = { 
				activos: [],
				pasivos: []
			}
		},
		closeAlert() {
			this.alert.show = false;
		},
		acceptAlert() {
			this.alert.show = false;

			if (this.alert.options == "deletecustomer") {
				this.deleteCustomer();
			}
		},
		showAlert(type, header, body, options = null) {
			type = type == null ? "danger" : type;
			this.alert.type = type;
			this.alert.header = header;
			this.alert.body = body;
			this.alert.show = true;
			this.alert.options = options != null ? options : null;
		},
		clearVerificationBalancePolling() {
			if (this.verificationBalancePollingTimer) {
				clearTimeout(this.verificationBalancePollingTimer);
				this.verificationBalancePollingTimer = null;
			}
		},
		scheduleVerificationBalancePoll() {
			this.clearVerificationBalancePolling();
			this.verificationBalancePollingTimer = setTimeout(() => {
				this.pollVerificationBalanceJobStatus();
			}, 5000);
		},
		applyVerificationBalanceJobState(job = {}) {
			this.verificationBalanceJobId = job.jobId || this.verificationBalanceJobId;
		},
		getVerificationBalanceJobData(response = {}) {
			if (response.data && Array.isArray(response.data.activos) && Array.isArray(response.data.pasivos)) {
				return response.data;
			}

			if (response.result && Array.isArray(response.result.activos) && Array.isArray(response.result.pasivos)) {
				return response.result;
			}

			if (Array.isArray(response.activos) && Array.isArray(response.pasivos)) {
				return response;
			}

			return null;
		},
		isVerificationBalanceJobCompleted(response = {}) {
			return response.status === "COMPLETED"
				|| (
					response.success === true
					&& Number(response.status) === 200
					&& Boolean(this.getVerificationBalanceJobData(response))
				);
		},
		showVerificationBalanceError() {
			this.showAlert(
				"warning",
				"No fue posible consultar los datos",
				`Vuelva a intentrlo y si el problema persiste comuniquese con su administrador`
			);
		},
		completeVerificationBalanceJob(response = {}) {
			const reportData = this.getVerificationBalanceJobData(response);

			if (!reportData) {
				this.showVerificationBalanceError();
				return;
			}

			this.validateLengthOfReport( reportData, "El periodo solicitado no posee registros contables", () => {
				console.log( "completeVerificationBalanceJob -> reportData:", reportData );
				this.DataTable = reportData;
			} );
		},
		finishVerificationBalanceJob() {
			this.verificationBalanceRunning = false;
			this.verificationBalanceAction = null;
			this.loading = false;
		},
		async pollVerificationBalanceJobStatus() {
			if (!this.verificationBalanceJobId) {
				this.finishVerificationBalanceJob();
				return;
			}

			try {
				const response = await this.$API.accountingreports.getVerificationBalanceJobStatus(this.verificationBalanceJobId);
				this.loadingMessage = response.message || "Consultando estado del proceso...";

				this.applyVerificationBalanceJobState(response);

				if (this.isVerificationBalanceJobCompleted(response)) {
					this.clearVerificationBalancePolling();
					this.completeVerificationBalanceJob(response);
					this.finishVerificationBalanceJob();
					return;
				}

				if (response.status === "FAILED") {
					this.clearVerificationBalancePolling();
					this.showVerificationBalanceError();
					this.finishVerificationBalanceJob();
					return;
				}

				this.scheduleVerificationBalancePoll();
			} catch (error) {
				this.clearVerificationBalancePolling();
				this.showVerificationBalanceError();
				this.finishVerificationBalanceJob();
			}
		},
		async getVerificationBalanceData(refresh = false){
			if (this.verificationBalanceRunning) {
				return;
			}

			this.loading = true;
			try {
				if(this.search.month == null || this.search.year == null){
					this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
					return;
				}
				if(String(this.search.year).length != 4){
					this.showAlert("danger", "Error", "El año debe tener 4 digitos");
					return;
				}
				this.cleanData();
				this.verificationBalanceRunning = true;
				this.verificationBalanceJobId = null;
				this.verificationBalanceAction = refresh ? 'refresh' : 'consult';
				this.clearVerificationBalancePolling();

				const payload = { ...this.search, type: this.SheetCheckBalanceType };

				if (refresh) {
					payload.refresh = true;
				}

				const response = await this.$API.accountingreports.sendVerificationBalanceJob(payload);

				// console.log( "getVerificationBalanceData -> response:", response );
				if (!response || response.success === false) {
					this.showVerificationBalanceError();
					this.finishVerificationBalanceJob();
					return;
				}

				this.applyVerificationBalanceJobState(response);

				if (this.isVerificationBalanceJobCompleted(response)) {
					this.completeVerificationBalanceJob(response);
					this.finishVerificationBalanceJob();
					return;
				}

				if (response.status === "FAILED" || !this.verificationBalanceJobId) {
					this.showVerificationBalanceError();
					this.finishVerificationBalanceJob();
					return;
				}

				this.scheduleVerificationBalancePoll();
			} catch (error) {
				this.showVerificationBalanceError();
				this.finishVerificationBalanceJob();
			} finally {
				if (!this.verificationBalanceRunning) {
					this.loading = false;
				}
			}
		},
		validateLengthOfReport( data, message, next ) {
			const { activos, pasivos } = data;

			if( activos.length === 0 && pasivos.length === 0 ) {
				this.showAlert(
					"warning",
					"No se encontraron datos",
					message
				);
			} else {
				next();
			}
		},
		printPreview(userData) {
			moment.locale('es_SV');

			const { activos, pasivos } = this.DataTable;

			this.print = {
				show: true,
				data: {
					activos,
					pasivos,	
					userData: userData,
				},
				balanceDate: this.balanceDate,
				lastDayOfDate: this.balanceDateComplete.endOf('month').format( 'DD' ),
				balanceType: this.typesDitionary[ this.SheetCheckBalanceType ],
				SheetCheckBalanceType: this.SheetCheckBalanceType
			}
		},
	},
}
</script>

<style scoped>
.book-radio {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	font-size: 16px;
	color: black;
	margin: 0 0 20px 12px;
}
.book-radio label {
	cursor: pointer;
}
.book-radio input[type="radio"] {
		display: none;
}
.book-radio .custom-radio {
	width: 20px;
	height: 20px;
	border: 2px solid #777;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	cursor: pointer;
	transition: background-color 0.3s;
	align-self: center;
}
.book-radio .custom-radio::before {
	content: '';
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: background-color 0.3s;
}
.book-radio input[type="radio"]:checked + .custom-radio::before {
	background-color: #3498DB;
}
.book-radio label {
	display: flex;
	gap: 8px;
	align-items: center;
}
.bar {
max-width: 100%;
background-color: rgb(60, 60, 60) !important;
color: white !important;
border-style: solid;
border-color: black;
border-radius: 15px !important;
margin: 16px 12px !important;
}
.btn-add{
background-color: #3498DB  !important;
color: white;
}
.btnsave{
background-color: #00A178 !important;
color: white;
}
.btnclean{
background-color: #F29D35 !important;
color: white;
}
.btndelete{
background-color: #E3191E !important;
color: white;
}
.check-balance-grid-wrapper {
	width: 100%;
	max-width: 100%;
	overflow-x: auto;
}
.check-balance-grid {
	min-width: 760px;
}
</style>
